import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { OrganizationAPIResponse, OrganizationInterface, organizationI } from 'app/core/interfaces/organization';
import Organization from 'app/core/models/Organization';

import { OrganizationAdapter } from 'app/core/adapters/organization.adapter';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private http: HttpClient, private organizationAdapter: OrganizationAdapter) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  public searchByToken(id: string) {
    return this.http.get<OrganizationInterface>(`${environment.apiUrl}/secretarias-organization/token_id/${id}`);
  }

  public create(params: any) {
    return this.http.post(`${environment.apiUrl}/secretarias-organization`, params);
  }

  public createNew(organization: OrganizationInterface) {
    const organizationFHIR = this.organizationAdapter.adaptToAPIFormat(organization);
    organizationFHIR.token_id = localStorage.getItem('token_id') ?? '';

    return this.http.post(`${environment.apiUrl}/secretarias-organization`, organizationFHIR);
  }

  public update(id: string, params: organizationI) {
    return this.http.put(`${environment.apiUrl}/secretarias-organization/${id}`, params);
  }

  public updateNew(id: string, organization: OrganizationInterface) {
    const organizationFHIR = this.organizationAdapter.adaptToAPIFormat(organization);

    return this.http.put(`${environment.apiUrl}/secretarias-organization/${id}`, organizationFHIR);
  }

  public delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-organization/${id}`);
  }

  public show(id: string) {
    return this.http.get<Organization>(`${environment.apiUrl}/secretarias-organization/${id}`);
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-organization`);
  }

  public showNew(organization_id: string): Observable<OrganizationInterface> {
    return this.http
      .get<OrganizationAPIResponse>(`${environment.apiUrl}/secretarias-organization/${organization_id}`)
      .pipe(map((organization: OrganizationAPIResponse) => this.organizationAdapter.adapterToModel(organization)));
  }

  public listNew(): Observable<OrganizationInterface[]> {
    return this.http
      .get<OrganizationAPIResponse[]>(`${environment.apiUrl}/secretarias-organization`)
      .pipe(
        map((organization: OrganizationAPIResponse[]) =>
          organization.map((item: OrganizationAPIResponse) => this.organizationAdapter.adapterToModel(item))
        )
      );
  }
}
